import type { ReactNode } from 'react';

export const symbol_media_bluetooth_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M798-80 620-257l-44 45q-6 7-15 7t-16-7q-6-6-6-14.5t6-15.5l44-46-169-169v187q0 63-43.5 106.5T270-120q-63 0-106.5-43.5T120-270q0-63 43.5-106.5T270-420q26 0 50 8t40 22v-127L91-786q-9-9-9.5-21t8.5-21q9-9 21.5-9t21.5 9l707 706q9 9 9 21t-9 21q-9 9-21 9t-21-9Zm-78-330 65-65-65-65v130ZM420-626l-60-60v-124q0-13 8.5-21.5T390-840h174q13 0 21.5 8.5T594-810v75q0 13-8.5 21.5T564-705H420v79Zm421 151L733-367l95 95q5 5 5 13t-5 13q-5 5-13.5 5t-13.5-5L548-499q-5-5-5-13t5-13q5-5 13-5t13 5l106 106v-196h21l140 140Z"
		/>
	</svg>
);
